import React, { useContext, useEffect, useState } from "react";

import { List, Card, Button, Typography, notification } from "antd";
import { StarFilled, ClockCircleFilled } from "@ant-design/icons";
import { useHistory } from "react-router";
import axios from "axios";
import { NavContext } from "../../../state/NavContext";

const { Meta } = Card;
const { Text, Paragraph, Link } = Typography;

const MovieList = (props) => {
  const history = useHistory();
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);

  useEffect(() => {
    setActiveIndex("movies");
    setIsSideBarActive(false);
  }, [setActiveIndex, setIsSideBarActive]);

  const defaultData = [
    {
      id: null,
      title: null,
      description: null,
      year: null,
      duration: null,
      rating: null,
      image_url: "home",
    },
    {
      id: null,
      title: null,
      description: null,
      year: null,
      duration: null,
      rating: null,
      image_url: "home",
    },
    {
      id: null,
      title: null,
      description: null,
      year: null,
      duration: null,
      rating: null,
      image_url: "home",
    },
    {
      id: null,
      title: null,
      description: null,
      year: null,
      duration: null,
      rating: null,
      image_url: "home",
    },
  ];

  const [movies, setMovies] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isCanceled, setIsCanceled] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      axios
        .get("https://backendexample.sanbersy.com/api/data-movie")
        .then((res) => {
          if (!isCanceled) {
            setMovies(res.data);
            setIsLoaded(true);
          }
        })
        .catch((err) => {
          if (!isCanceled) {
            notification.error({
              message: "Error Loading Data",
              description: err.response.data.message,
              placement: "topRight",
            });
            console.log(err.response.data.message);
            setIsLoaded(true);
          }
        });
    }

    // cleanup component unmount
    return function () {
      setIsCanceled(true);
    };
  }, []);

  const navigateTo = (path) => {
    setActiveIndex("movies");
    history.push(path);
  };

  return (
    <>
      <div className="top-list">
        <h2>{props.maxItem !== null ? "Latest Movies" : "All Movies"}</h2>
        {props.maxItem !== null ? (
          <Button onClick={() => navigateTo("/movies")} type="link">
            View More
          </Button>
        ) : (
          <></>
        )}
      </div>
      <div className="list-body">
        <List
          grid={{ gutter: 16, column: 4, sm: 1, md: 2, xs: 1 }}
          dataSource={isLoaded ? movies : defaultData}
          renderItem={(item, index) => {
            if (index >= props.maxItem && props.maxItem !== null) {
              return;
            }

            return (
              <List.Item>
                <Card
                  className="card-item-list"
                  loading={!isLoaded}
                  cover={
                    <img
                      onClick={() => navigateTo(`/movies/detail/${item.id}`)}
                      src={
                        isLoaded === true
                          ? item.image_url
                          : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAA1BMVEXR0dFCxnTBAAAASElEQVR4nO3BgQAAAADDoPlTX+AIVQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwDcaiAAFXD1ujAAAAAElFTkSuQmCC"
                      }
                      alt={item.title}
                      className="card-image"
                    />
                  }
                >
                  <Meta
                    title={
                      <Link
                        onClick={() => navigateTo(`/movies/detail/${item.id}`)}
                      >
                        {item.title} ({item.year})
                      </Link>
                    }
                    description={
                      <Paragraph
                        type="secondary"
                        ellipsis={{ rows: 3, expandable: false }}
                      >
                        {item.description}
                      </Paragraph>
                    }
                  />
                  <div className="card-bottom">
                    <div>
                      <StarFilled style={{ color: "gold" }} />
                      <Text> {item.rating}/10</Text>
                    </div>
                    <div>
                      <ClockCircleFilled />
                      <Text> {item.duration} min</Text>
                    </div>
                  </div>
                  <Button
                    block
                    className="card-button-detail"
                    onClick={() => navigateTo(`/movies/detail/${item.id}`)}
                  >
                    View Details
                  </Button>
                </Card>
              </List.Item>
            );
          }}
        />
      </div>
    </>
  );
};

export default MovieList;
